const visibilities = [
  {
    name: "INTERNAL_USERS",
    value: "Somente para usuários internos (para validação prévia - preview)",
  },
  { name: "AUTHENTICATED_USERS", value: "Somente para usuários logados" },
  { name: "EVERYONE", value: "Todos usuários (Logados e não-logados)" },
];

export default visibilities;
